import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import useLanguage from "../../utils/useLanguage";

import classes from "../../components/Modal.module.css";

import SectionDivider from "../../components/SectionDivider";
import CustomInput from "../../components/CustomInput";
import CustomButton from "../../components/CustomButton";
import AddAnotherButton, { GENDER } from "../../components/AddAnotherButton";

import previousIcon from "../../assets/previous_icon.png";
import nextIcon from "../../assets/next_icon.png";
import addIcon from "../../assets/add_icon.png";
import CustomInputWithUnit from "../../components/CustomInputWithUnit";

export default function SubTreatmentsSection({
  sendDataToParent,
  errorFields,
  validateFields,
  initialSubTreatments = [{ subTreatmentName: "", subTreatmentPrice: null }],
}) {
  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");
  const [page, setPage] = useState(1);

  // sub treatments
  const [subTreatments, setSubTreatments] = useState(initialSubTreatments);

  const spanStyles = currentDirection === "rtl" ? classes.shortSpan : null;

  const handleInputChange = (e, pageIndex) => {
    const { name, value } = e.target;

    setSubTreatments((prevSub) =>
      prevSub.map((item, index) => {
        if (index !== pageIndex) return item;

        return { ...item, [name]: value };
      })
    );
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (page < subTreatments.length) setPage(page + 1);
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    if (page > 1) setPage(page - 1);
  };

  // sub treatments
  const handleAddSubTreatment = (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    const newSubTreatment = { subTreatmentName: "", subTreatmentPrice: null };
    setSubTreatments((prevSubTreatments) => [
      ...prevSubTreatments,
      newSubTreatment,
    ]);
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    sendDataToParent(subTreatments);
  }, [subTreatments]);

  return (
    <div>
      <SectionDivider title="subTreatment" />
      <div
        className={`add-shipped-container-container-part ${classes.flexableForm} ${classes.flexableFormWithPadding}`}
      >
        {subTreatments?.map((item, index) => {
          if (index + 1 === page) {
            return (
              <>
                <div className={classes.inputContainer}>
                  <span className={spanStyles}>{t("treatmentName")}: </span>
                  <CustomInput
                    name="subTreatmentName"
                    value={item.subTreatmentName}
                    onChange={(e) => handleInputChange(e, index)}
                    flex={true}
                    errorText={errorFields[`subTreatmentName-${index}`]}
                  />
                </div>

                <div className={classes.inputContainer}>
                  <span className={spanStyles}>{t("price")}: </span>
                  <CustomInputWithUnit
                    name="subTreatmentPrice"
                    value={item.subTreatmentPrice}
                    onChange={(e) => handleInputChange(e, index)}
                    type="money"
                    flex={true}
                    errorText={errorFields[`subTreatmentPrice-${index}`]}
                    unit={t("IQD")}
                  />
                </div>
              </>
            );
          }
          return null;
        })}
      </div>
      <div>
        <div className={""}>
          {subTreatments?.length ? (
            <div className={"add-shipped-container-next-previous"}>
              <CustomButton
                variant="blank"
                title={t("previous")}
                onClick={handlePrevious}
                disabled={page === 1}
                icon={currentDirection === "ltr" ? previousIcon : nextIcon}
                iconSize={15}
              />
              <CustomButton
                title={t("next")}
                variant="blank"
                onClick={handleNext}
                disabled={page === subTreatments.length}
                icon={currentDirection === "ltr" ? nextIcon : previousIcon}
                iconSize={15}
                reverseIcon
              />
            </div>
          ) : null}
        </div>
        <div className={"add-shipped-container-add-another"}>
          <AddAnotherButton
            onClick={handleAddSubTreatment}
            variant="blank"
            title={t("addSubTreatment")}
            icon={addIcon}
            iconSize={16}
            gender={GENDER.FEMALE}
            arrayLength={subTreatments?.length}
          />
        </div>
      </div>
    </div>
  );
}
